"use strict";
function initBlock(block) {
    const impressions = block.querySelectorAll(".impression-case");
    const buttonElement = document.createElement("button");
    buttonElement.innerText = "Toon alles";
    buttonElement.classList.add("impression-cases__show-all");
    buttonElement.classList.add("button");
    buttonElement.addEventListener("click", () => {
        block.classList.add("show-all");
    });
    block.appendChild(buttonElement);
    const setMaxHeight = () => {
        const maxHeight = impressions[9].offsetTop + impressions[9].offsetHeight;
        block.style.maxHeight = `${maxHeight}px`;
    };
    window.addEventListener("resize", setMaxHeight);
    setMaxHeight();
}
window.addNavigationCallback(() => {
    const blocks = document.querySelectorAll(".impression-cases");
    blocks.forEach(initBlock);
}, "init-impressions");
